import type { NewToastMessage, ToastMessage } from "@winamp/toast/schema.ts";
import { createContext, useContext } from "react";

interface IToastContext {
  addToast: (toast: NewToastMessage) => void;
  removeToast: (id: string) => void;
  toasts: Array<ToastMessage>;
}

export const ToastContext = createContext<IToastContext | undefined>(undefined);

export function useToastContext() {
  const context = useContext(ToastContext);

  if (context === undefined) {
    throw new Error(
      "useToastContext must be used withing an ToastContextProvider",
    );
  }

  return context;
}
